<template>
  <div>
    <!-- 我的询价 -->
    <form action="" class="w-100 layui-form" method="post">
      <div class="user-info3 w-100 between-center">
        <!-- <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="——"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <el-select v-model="formData.state" clearable placeholder="订单状态">
          <el-option
            v-for="item in orderState"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input placeholder="需求描述" v-model="formData.demand"></el-input>
        <div class="btns">
          <input
            class="layui-btn layui-btn-normal"
            value="确定"
            @click="getOrderInquiryList"
            type="button"
          />
          <input type="reset" class="layui-btn" value="重置" @click="reset" />
        </div>
      </div>
      <!-- <div class="user-info3 w-100 between-center">
        <el-input placeholder="产品名称" v-model="proName"></el-input>
        <el-input placeholder="订单编号" v-model="suid"></el-input>
        <div class="btns">
          <input
            class="layui-btn layui-btn-normal"
            value="确定"
            @click="getOrderInquiryList"
          />
          <input type="reset" class="layui-btn" value="重置" @click="reset" />
        </div>
      </div> -->
    </form>
    <div class="w-100" v-if="tableData.length === 0">
      <div class="no-content">
        <img src="../../../static/img/no_data5.png" />
      </div>
    </div>
    <table class="table table-hover w-100" v-if="tableData.length !== 0">
      <tr>
        <th width="270">
          <label class="checkbox-inline">需求描述</label>
        </th>
        <th width="160">采购人</th>
        <th width="130">联系方式</th>
        <!-- <th width="130">金额</th> -->
        <th width="130">状态</th>
        <th width="180">日期</th>
        <th>操作</th>
      </tr>
      <template v-for="item in tableData">
        <tr>
          <td>
            <label class="checkbox-inline"
              ><input
                type="checkbox"
                :checked="item.checked"
                class="checkbox-style sonCheckbox"
                name=""
                id=""
                value=""
              />{{ item.demand }}</label
            >
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.phone }}</td>
          <!-- <td>15200.00</td> -->
          <td>
            {{
              item.state === 1
                ? '跟进中'
                : item.state === 2
                ? '已成交'
                : '已终止'
            }}
          </td>
          <td>{{ item.whenCreated }}</td>
          <td>
            <!-- <a href="" class="btns orange">支付</a>
            <a href="" class="btns blue">编辑</a> -->
            <el-button
            type="info"
            size="small"
            :disabled="item.state !==2"
            round
            @click="orderDetail(item)"
            >查看详情</el-button
          >
          </td>
        </tr>
      </template>
      <!-- <tr>
				<td><label class="checkbox-inline"><input type="checkbox" class="checkbox-style sonCheckbox" name="" id="" value="" />HLX-10-6060-45铝型材</label></td>
				<td>王旺旺</td>
				<td>是</td>
				<td>15200.00</td>
				<td>待支付</td>
				<td>2021.05.04</td>
				<td>
					<a href="" class="btns orange">支付</a>
					<a href="" class="btns blue">编辑</a>
				</td>
			</tr> -->
    </table>
    <!-- <div class="user-info4 w-100 between-center" v-if="tableData.length !== 0">
      <div class="f-l between-center">
        <label class="checkbox-inline"
          ><input
            type="checkbox"
            class="checkbox-style allCheckbox"
            name=""
            id=""
            value=""
          />&nbsp;</label
        >
        <span>删除所选</span>
        <span>设置为已读</span>
      </div>
      <div class="fanye gray">
        <div class="pull-right">
          <ul class="between-center">
            <li><a href="">&lt;</a></li>
            <li><a href="" class="active">1</a></li>
            <li><a href="">2</a></li>
            <li><a href="">3</a></li>
            <li><a href="">4</a></li>
            <li><a href="">5</a></li>
            <li><a href="">6</a></li>
            <li><a href="">&gt;</a></li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  message
} from '@/common/common.js'
import { getOrderInquiry } from '../../common/http';
export default {
  data () {
    return {
      orderState: [{
        label: '跟进中',
        value: 1
      },
      {
        label: '已成交',
        value: 2
      },
      {
        label: '已终止',
        value: 3
      }],
      stateValue: '',
      spit: '',
      date: '',
      suid: '',
      proName: '',
      formData: {
        demand: "",
        state: ''
      },
      tableData: []
    }
  },
  mounted () {
    this.$emit('change_bread', 2);
    if(this.$route.query.data) {
      this.formData.state = this.$route.query.data;
    }
    this.getOrderInquiryList();
  },
  methods: {
    getOrderInquiryList () {
      getOrderInquiry(this.formData).then(res => {
        if (res.result) {
          this.tableData = res.data.rows.map((item) => {
            item.checked = false;
            return item;
          });
        }
      })
    },
    confirm () {
      message({
        message: '功能暂未开放',
        type: 'warning'
      })
    },
    reset () {
      this.formData = {
        demand: "",
        state: ''
      }
      this.getOrderInquiryList();
    },
    // 查看详情
    orderDetail (row) {
      this.$router.push({
        path: '/orderDetails',
        name: 'orderDetails',
        query: {
          uid: row.order.uid
        }
      });
    }
  }
}
</script>

<style scoped>
.el-range-editor.el-input__inner {
  width: 31.5%;
}
.el-select {
  width: 31.5%;
  height: 2.875rem;
  border-radius: 0.375rem;
}
.el-input {
  width: 31.5%;
  height: 2.875rem;
  border-radius: 0.375rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/meInquiry.vue